import { api } from '@/services'
import { useCapitalize, useEmpty } from '@/utilsV2'

type Localities = {
    zipcode?: string
    city?: string
    state?: string
    district?: string
    street?: string
}

type Response = {
    message: string
    zipcode: string
    state: string
    city: string
    district: string
    street: string
}

async function useLocality(
    InputsData: Localities
): Promise<[Response: Response, Error: string, Loading: boolean]> {
    // * Get the Address info
    const { zipcode, city, state, district, street } = InputsData

    // * Set Return initial value
    var Response: Response = null,
        Error = null,
        Loading = true

    const Controller = new AbortController()

    // * Get address by zipcode
    const MakeRequestByZipcode = async () => {
        try {
            const resp = await api.get(`/Locality/${zipcode}`, {
                signal: Controller.signal
            })
            Response = {
                message: 'Endereço encontrado com sucesso!',
                zipcode: resp.data.zip,
                state: resp.data.state,
                city: resp.data.city,
                district: resp.data.district,
                street: resp.data.street
            }
        } catch (error) {
            Error = 'Não foi possível encontrar o endereço'
        } finally {
            Loading = false
        }
    }

    // * Get zipcode by address
    const MakeRequestByAddress = async () => {
        try {
            const resp = await api.get(`/Locality`, {
                signal: Controller.signal,
                params: {
                    City: useCapitalize(city),
                    State: useCapitalize(state),
                    District: useCapitalize(district),
                    Street: useCapitalize(street)
                }
            })
            const { result } = resp.data
            Response = {
                message: 'CEP encontrado pelo endereço!',
                zipcode: result[0].zip,
                state: result[0].state,
                city: result[0].city,
                district: result[0].district,
                street: result[0].street
            }
        } catch (error) {
            Error = 'Não foi possível encontrar o CEP pelo endereço!'
        } finally {
            Loading = false
        }
    }

    // * Verify if the address is empty
    if (useEmpty(InputsData)) {
        Controller.abort()
        Error = 'Nenhum dado foi informado.'
        Loading = false
        return [Response, Error, Loading]
    }

    // * Verify if search is by zipcode
    if (useEmpty(zipcode)) {
        await MakeRequestByAddress()
    } else {
        await MakeRequestByZipcode()
    }

    Controller.abort()
    return [Response, Error, Loading]
}

export { useLocality }
